import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})

export class DispatchService {

  // private ip = 'http://35.232.140.117:3800';

  constructor(
    private httpClient: HttpClient
  ) { }

  sendEmail_CF(data){
    console.log(data);
    console.log(this.getCompanyID());
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.emailsend+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/MailSenderPreview/'+this.getCompanyID(),data,
    //   { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});

  }

  pilotoSMTP(datos){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pilotoSMTPGen + this.getCompanyID(),datos);
  }

  public sendMail(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pulse.sendMail+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/MailSender/'+this.getCompanyID(),data,
    //   { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getPilotoData(data){
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.pulse.getEncuetasPulsePiloto+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/getPiloto/'+this.getCompanyID(),data,
    //   { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  private getCompanyID():string{
    const token = localStorage.getItem('companyID');
    return token;
  }


  ////////////////OBTIENE EL TOKEN DEL USUARIO EN LINEA
  private getToken():string{
    const token = localStorage.getItem('token');
    return token;
  }
  sendEmailPulse(datos){
    console.log("entro service");
    console.log(datos);

    return this.httpClient.post(DATOS_API.url+ DATOS_API.endpoints.pulse.envioCorreo+this.getCompanyID(),datos);


  }


}
